var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85981 0.887825L9.16903 0.205261C8.98212 0.0183461 8.6733 0.0183461 8.47826 0.205261L5.0325 3.65091L1.5218 0.140247C1.33481 -0.046749 1.02599 -0.046749 0.831026 0.140247L0.140248 0.831019C-0.0467494 1.01793 -0.0467494 1.32675 0.140248 1.52179L3.6429 5.02441L0.205263 8.47827C0.0183463 8.66518 0.0183463 8.974 0.205263 9.16904L0.89604 9.85981C1.08296 10.0467 1.39177 10.0467 1.58682 9.85981L5.0325 6.41408L8.47826 9.85981C8.66517 10.0467 8.97399 10.0467 9.16903 9.85981L9.85981 9.16904C10.0467 8.98213 10.0467 8.67331 9.85981 8.47827L6.40593 5.03254L9.85169 1.58689C10.0467 1.39168 10.0467 1.08287 9.85981 0.887825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.854c9d3ce2c4bc6ba3b1aa56a7d80802.svg";
export { ForwardRef as ReactComponent };